<template>
	<div class="jrp">
		<nav class="navbar navbar-light bg-white">
			<div class="container justify-content-start">
				<router-link class="navbar-brand" to="/">
					<img src="../assets/images/logo.png">
				</router-link>
				<form class="search-form ml-4" @submit.prevent="subSearch">
					<div class="row">
						<div class="col p-0">
							<input class="w-100 border-right-0" type="text" placeholder="Job title, keywords" v-model="searchForm.keyword" />
						</div>
						<div class="col p-0">
							<input class="w-100 border-right-0" type="text" placeholder="City, state, zip code" v-model="searchForm.location" />
						</div>
						<div class="col-auto align-self-center pl-0 pr-0">
							<button type="submit" class="btn btn-primary rounded-0">
								Search Jobs
							</button>
						</div>
						<div class="col-auto pl-0 d-md-none">
							<button type="button" class="btn btn-link pl-4 pr-0" @click.prevent="toggleFilters">
								<i class="material-icons">
									filter_list
								</i>
							</button>
						</div>
					</div>
				</form>
			</div>
		</nav>
		<div class="container mt-5 mb-2">
			<router-view ref="child"></router-view>
			<footer class="mt-5">
				<ul class="nav">
					<li class="nav-item">
						<div class="nav-link pl-0 pr-1">&copy; 2019 rightjobtoday.com</div>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" to="/privacy">Privacy Policy</router-link>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#" @click.prevent="openSupportForm">Contact Us</a>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" to="/unsubscribe">Unsubscribe</router-link>
					</li>
					<li class="nav-item">
						<router-link class="nav-link" to="/terms">Terms and Conditions</router-link>
					</li>
				</ul>
			</footer>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Subpage',
  data () {
    return {
      email: '',
      justSubscribed: false,
      pageLabels: {
        "privacy": "Privacy Policy",
        "unsub": "Manage Your Subscription"
      }
    };
  },
  methods: {
    isSearchPage () {
      return this.$route.name === 'search';
    },
    subSearch () {
      this.updateSearch();
      this.search().then(() => {
        if (this.isSearchPage()) {
          this.$refs.child.renderJobs();
        }
      }).catch(e => {
        console.log(e);
      });
    },
    toggleFilters () {
      if (this.isSearchPage()) {
        this.$refs.child.toggleFilters();
      }
    },
    subscribe () {
      axios.post(
        process.env.VUE_APP_METRICS_API + '/subscribe',
        {
          user: {
            email: this.email,
            pid: this.$store.state.user.pid
          },
          customFields: [
            {
              name: 'MERGE_KEYWORD',
              value: this.searchForm.keyword
            },
            {
              name: 'MERGE_LOCATION',
              value: this.searchForm.location
            }
          ]
        }
      ).then(res => {
        if (res.data.success) {
          this.$store.commit('inbound', {email: this.email});
          this.justSubscribed = true;
        }
      }).catch(() => {});
    }
  },
  computed: {
    askForEmail () {
      return (typeof this.$store.state.user.email === undefined || this.$store.state.user.email === "")
    },
    subpageHeading () {
      return this.pageLabels[this.$route.name];
    }
  }
}
</script>

<style scoped lang="scss">
  .mjt-footer__link {
    cursor: pointer;
  }
  .mjt-header {
    .mjt-header__inner {
      position: static;
      margin: 0px 20px;
      .mjt-header__form {
        -ms-flex-direction: column;
        flex-direction: row;
        padding: 0;
        min-height: 0;
      }
    }
  }
</style>
